<template>
  <section
    :id="element.Oid + '-element'"
    style="position: relative; z-index: 1000"
    :style="{
      width: `${element.startWidth * 100}%`,
      left: `${100 * (1 + element.startWidth) * element.startPosition - 100 * element.startWidth}%`,
      opacity: `${element.startOpacity}`,
      transform: `scale(${element.startScale * scaleFactor})`,
      minHeight: '120px'
    }"
    v-observe-visibility="{
      callback: visibilityChanged,
      throttle: 300,
    }"
  >
    <video v-if="elementVisible" v-bind="playerProps" ref="video">
      <source :src="element.url" type="video/mp4" />
    </video>
    <div v-if="element.text" class="ql-editor" v-html="element.text" />
  </section>
</template>

<script>

export default {
  components: {},

  props: {
    element: { type: Object, default: () => {} },
    scaleFactor: { type: Number, default: 1 },
    debugMode: { type: Boolean, default: false }
  },

  data() {
    return {
    };
  },

  watch: {},

  methods: {
    visibilityChanged (isVisible) {
      if(this.element.isBackground) {
        if(isVisible) {
          this.$store.dispatch("narratives/setActiveBackground", this.element);
        } else {
          this.$store.dispatch("narratives/removeActiveBackground", this.element);
        }
      } else if(this.element.videoControls) {
        const videoElement = this.$refs.video;
        if(isVisible) {
          videoElement.pause()
        }
      }
    },
  },

  computed: {
    playerProps() {
      return {
        autoplay: this.element.videoControls ? undefined : 'autoplay',
        controls:  this.element.videoControls ? 'controls': undefined,
        loop: this.element.videoControls ? undefined : 'loop',
      }
    },
    elementVisible() {
      return !this.element.isBackground
    }
  },

  mounted() {},
};
</script>

<style></style>
